import index from '../components/index'
import create from '../components/create'
import edit from '../components/_id/edit'
import store from '@/store'
import { ToastProgrammatic as Toast } from 'buefy'


export default [
    {
        path: '/releases',
        component: index,
        name: 'releases',
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            let roles = store.state.auth.roles
            let isRoleValid = roles.includes('serviceperson') || roles.includes('superadmin') || roles.includes('gatekeeper')
            if (isRoleValid) {
                return next()
            } else {
                Toast.open({
                    type:'is-danger',
                    message:`You have no access to: ${to.path}`
                })
                store.commit('SET_LOADING',false)
                return next({
                    name:'tickets'
                })
            }
        },
    },
    {
        path: '/releases/create',
        component: create,
        name: 'releases.create',
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            let roles = store.state.auth.roles
            let isRoleValid = roles.includes('serviceperson') || roles.includes('superadmin') || roles.includes('gatekeeper')
            if (isRoleValid) {
                return next()
            } else {
                Toast.open({
                    type:'is-danger',
                    message:`You have no access to: ${to.path}`
                })
                store.commit('SET_LOADING',false)
                return next({
                    name:'tickets'
                })
            }
        },
    },
    {
        path: '/releases/:id/edit',
        component: edit,
        name: 'releases.edit',
        props: { default: true },
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
            return next()
        },
    },
]